export const COMMENT_ANCHOR_PREFIX = "#comment_wrapper_";
export const ALL_COMMENTS_ANCHOR = "#all_comments";
